export const MOBILE_MAX_WIDTH_PX = 767.98;

export function isMobileViewport() {
    return typeof window !== 'undefined' && window.innerWidth <= MOBILE_MAX_WIDTH_PX;
}

export function initialSidebarOpen() {
    if (typeof window === 'undefined') return true;
    return window.innerWidth >= 768;
}

export function collapseFilterSidebarOnMobile(setSidebarOpen) {
    if (isMobileViewport()) {
        setSidebarOpen(false);
    }
}

export function formatYearRangeLabel(yearRange) {
    if (!yearRange) return '';
    return yearRange.replace('_', '-');
}

export function joinFilterSummaryParts(parts) {
    return parts.filter(Boolean).join(' · ');
}
